<div class="section-wrapper">
  <div class="section-header">
    <ng-icon class="section-icon" [name]="'heroUsers'" [size]="'24px'" [color]="'#822AC6'"
      [strokeWidth]="'2'"></ng-icon>
    <div class="section-heading">{{ 'ACCOUNT.USERS.TEAM_MEMBERS' | translate }}</div>
  </div>
  <div class="section-info">
    <img class="icon" [src]="'assets/images/info-icon-circle.svg'">
    <span class="text">{{'ACCOUNT.USERS.TEAM_MEMBERS_DESCRIPTION' |
      translate}}</span>
  </div>
  <div class="section-content-wrapper">
    <div class="section-content">
      <div class="section-content-label">{{'ACCOUNT.USERS.USERS' | translate}}</div>
      <rosie-button [customClass]="'action narrow slimmer text-sm'" [translationKey]="'COMMON.ADD'"
        [iconPrefixConfig]="{name: 'heroPlus', size: '18px', strokeWidth: '2', color: '#822ac6'}"
        (click)="handleUser()"></rosie-button>
    </div>
    <div class="section-content">
      <div class="section-table-wrapper mt-lg">
        <div class="section-table-header">
          <div class="section-table-header-item flex-full email">{{'ACCOUNT.USERS.EMAIL' | translate}}</div>
          <div class="section-table-header-item flex-full">{{'ACCOUNT.USERS.ROLE' | translate}}</div>
          <div class="section-table-header-item flex-full">{{'ACCOUNT.USERS.LAST_ACTIVE' | translate}}</div>
          <div class="section-list-icons edit rosie-invisible">
            <div class="icon"><ng-icon [name]="'heroPencilSquare'" [color]="'#6C6176'" [size]="'20px'"
                (click)="handleUser()"></ng-icon>
            </div>
          </div>
        </div>
        <div class="section-table-content" *ngFor="let user of businessUsers; let i = index; let last = last"
          [ngClass]="{'last': last}">
          <div class="section-table-item-content">
            <div class="section-table-item flex-full email" [ngClass]="{'inactive': user.inviteId}">
              <div class="d-flex align-items-center" *ngIf="!isMobileVersion">
                {{user.email}}
                <div class="pending-tag" *ngIf="user.inviteId">PENDING</div>
              </div>
              <ng-container *ngIf="isMobileVersion">
                {{user.email}}
              </ng-container>
            </div>
            <div class="section-table-item flex-full role">{{user.role?.title | capitalize}}</div>
            <div class="section-table-item flex-full" *ngIf="!user.inviteId">
              {{user.lastActive ? (user.lastActive | dateFormat:false:true) : 'N/A'}}</div>
            <div class="section-table-item flex-full" *ngIf="user?.inviteId">
              <rosie-button [customClass]="'secondary text-sm text-dark'" class="resend-invite-button"
                [inProgress]="resendInProgress === user.inviteId"
                [iconSuffixConfig]="{name: isMobileVersion ? '' : 'heroPaperAirplane', size: '16px', strokeWidth: '2', color: '#3b3540'}"
                [translationKey]="isMobileVersion ? 'Resend' : 'ACCOUNT.USERS.RESEND_INVITE'"
                (click)="resendInvite(user.inviteId)"></rosie-button>
            </div>
            <div class="section-list-icons edit">
              <div class="icon"><ng-icon [name]="'heroPencilSquare'" [color]="'#6C6176'" [size]="'20px'"
                  (click)="handleUser(i)"></ng-icon>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</div>
<ngx-smart-modal #userModal disableRefocus identifier="userModal" [customClass]="'users-modal'"
  (onAnyCloseEventFinished)="handleModalClose()">
  <div class="modal-title text-left">
    {{(isEditingExistingUser ? (isEditingAccountOwner ? 'ACCOUNT.USERS.EDIT_ACCOUNT_OWNER' : 'ACCOUNT.USERS.EDIT_USER')
    : 'ACCOUNT.USERS.ADD_USER') | translate}}
  </div>
  <div class="modal-subtitle with-border"></div>
  <div *ngIf="isEditingAccountOwner">
    <div class="modal-content">
      <div class="edit-account-owner-description">{{'ACCOUNT.USERS.EDIT_ACCOUNT_OWNER_DESCRIPTION' | translate}}</div>
    </div>
    <div class="modal-action-line with-border">
      <div class="d-flex align-items-center gap-2">
        <rosie-button (click)="userModal.close()" class="d-block" [customClass]="'secondary narrow'"
          [translationKey]="'COMMON.CANCEL'">
        </rosie-button>
        <rosie-button (click)="contactSupport()" class="d-block" [customClass]="'narrow slim'"
          [translationKey]="'COMMON.CONTACT_SUPPORT'">
        </rosie-button>
      </div>
    </div>
  </div>
  <div *ngIf="!isEditingAccountOwner">
    <div class="modal-content">
      <div class="section-item-wrapper justify-content-between">
        <div class="section-item-label  d-flex align-items-center">
          {{ 'ACCOUNT.USERS.EMAIL' | translate }}
          <img class="icon question ml-sm" [src]="'assets/images/setup-guide-question.svg'"
            [ngbTooltip]="'To change the email for a user, delete and re-add them as a new user. You can’t delete your own user; reach out to the account owner to help with that.'"
            tooltipClass="tooltip-wrapper">
        </div>
        <div class="w-100">
          <rosie-text [control]="temporaryUser" [placeholderTranslationKey]="'ACCOUNT.USERS.EMAIL'"
            [disabled]="isEditingExistingUser" [lowercaseOnly]="true"></rosie-text>
          <rosie-validation-error [show]="temporaryUser?.errors?.email && temporaryUser?.touched"
            [translationKey]="'COMMON.VALIDATION.PATTERN'"
            [translationAttributes]="{value: 'Email'}"></rosie-validation-error>
        </div>
      </div>
      <div class="section-item-wrapper justify-content-between align-items-start">
        <div class="section-item-label">{{ 'ACCOUNT.USERS.ROLE' | translate }}</div>
        <div class="w-100">
          <rosie-radio-group [control]="temporaryRole" [options]="roleOptions"></rosie-radio-group>
        </div>
      </div>
      <div class="section-item-wrapper align-items-center justify-content-start gap-0 mb-0">
        <ng-icon [name]="'heroInformationCircle'" [size]="'24px'" [color]="'#6C6176'" [strokeWidth]="'2'"
          class="mr-xs"></ng-icon>
        <span class="default-text">{{'ACCOUNT.USERS.MORE_ROLES' | translate}}</span>
        <span class="default-text text-underline ml-1 pointer" (click)="letUsKnow()">{{'ACCOUNT.USERS.LET_US_KNOW' |
          translate}}</span>
      </div>
      <rosie-alert *ngIf="errorMessage" [message]="errorMessage" [type]="'error'" class="d-block mt-4"
        [customClass]="'mb-0'"></rosie-alert>
    </div>
    <div class="modal-action-line with-border flex-wrap"
      [ngClass]="{'with-delete-action': editedItemIndex != null, 'delete-confirmation': removeActionInProgress}">
      <ng-container *ngIf="!removeActionInProgress">
        <ng-container *ngIf="editedItemIndex != null">
          <rosie-button [customClass]="'narrow slim text-sm secondary destructive'" [translationKey]="'COMMON.DELETE'"
            [ngClass]="{'rosie-invisible': isTheSameUser()}"
            [iconPrefixConfig]="{name: 'heroTrash', size: '18px', strokeWidth: '2', color: '#6C6176', hoverColor: '#9F1239'}"
            (click)="handleItemRemoveAction()"></rosie-button>
        </ng-container>
        <div class="d-flex align-items-center gap-2">
          <rosie-button (click)="userModal.close()" class="d-block" [customClass]="'secondary narrow'"
            [translationKey]="'COMMON.CANCEL'">
          </rosie-button>
          <rosie-button (click)="save()" class="d-block" [customClass]="'narrow slim'" [inProgress]="inProgress"
            [iconSuffixConfig]="{name: isEditingExistingUser ? '' : 'heroPaperAirplane', size: '16px', strokeWidth: '2', color: '#FFFFFF'}"
            [translationKey]="(isEditingExistingUser ? 'COMMON.SAVE' : 'ACCOUNT.USERS.SEND_INVITE')">
          </rosie-button>
        </div>
      </ng-container>
      <ng-container *ngIf="removeActionInProgress">
        <div class="destructive-wrapper">
          <div class="destructive-icon"><ng-icon [name]="'heroExclamationTriangleSolid'" [color]="'#BE123C'"
              [size]="'20px'" (click)="handleItem(i)"></ng-icon>
          </div>
          <div class="destructive-text">{{ 'COMMON.PERMANENTLY_DELETE' | translate }}</div>
        </div>
        <div class="d-flex align-items-center gap-2">
          <rosie-button (click)="handleItemRemoveCancel()" class="d-block" [customClass]="'secondary narrow'"
            [translationKey]="'COMMON.CANCEL'">
          </rosie-button>
          <rosie-button (click)="removeItem()" class="d-block" [customClass]="'narrow slim danger'"
            [inProgress]="inProgress" [translationKey]="'COMMON.YES_DELETE'">
          </rosie-button>
        </div>
      </ng-container>
    </div>
  </div>
</ngx-smart-modal>
<div class="roles-intercom-trigger rosie-invisible"></div>
<div class="general-intercom-trigger-help rosie-invisible"></div>